import { MessageResponseDto } from "@api/api";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { activityFormDefault } from "@factory/form/form.default";
import { ActivityFormRule, ActivityFormSchema } from "@factory/form/form.rule";
import { useQyCreateActivity } from "@factory/query/activity.query";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { FieldErrors, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

export function useNewActivity() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateActivity } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Activity is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addActivity, isLoading: isCreating } =
    useQyCreateActivity(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<ActivityFormSchema>({
    defaultValues: activityFormDefault,
    resolver: zodResolver(ActivityFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: ActivityFormSchema) => {
    const formData = mapCreateActivity(form);
    addActivity(formData);
  };
  const handleValidateError = (err: FieldErrors<ActivityFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
